import * as React from "react";
import styled from "styled-components";

import { DialogRoot } from "../components";
import { useAuth, useGlobalData } from "../contexts";
import { StripeTestButton } from "./common/StripeTestButton";
import { DrupalRouter } from "./modules/DrupalRouter";

export interface IDrupalAppProps {}

const Container = styled.div`
  min-width: 800px;
  padding: 0.5rem;
`;

const entryType = document.body.getAttribute("data-entry");
export const isBrcs = entryType === "brcs";

export const DrupalApp: React.FunctionComponent<IDrupalAppProps> = (props) => {
  const { setLanguageCode, loading, languages, setLanguage } = useGlobalData();
  const { user } = useAuth();

  React.useLayoutEffect(() => {
    if (!!user) {
      const logoutLink = document.getElementsByClassName("react-logout-li");
      if (logoutLink?.length > 0) {
        logoutLink[0].classList.remove("hidden");
      }
    }
  }, [user]);

  React.useEffect(() => {
    if (!loading) {
      const drupallanguage = localStorage.getItem("drupal-language");
      if (!drupallanguage) return;
      const langUpper = drupallanguage.toUpperCase();
      if (["FR", "NL", "EN"].includes(langUpper)) {
        setLanguageCode(langUpper === "EN" ? "FR" : langUpper);
        var languageDto = languages?.find((l) => l?.languageCode?.toUpperCase() === langUpper);
        setLanguage(languageDto);
      }
    }
  }, [languages, loading, setLanguage, setLanguageCode]);

  return (
    <Container>
      <DrupalRouter />
      <DialogRoot />
      <StripeTestButton />
    </Container>
  );
};
